module.exports = __webpack_public_path__ + "static/img/3.8af880a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/3.png
// module id = ajO4
// module chunks = 0